import { Navigate, useLocation } from "react-router-dom";
import { type ReactNode } from "react";
import { useAuthStore } from "./auth.store";

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const token = useAuthStore((s) => s.accessToken);
  const location = useLocation();
  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
